import { render, staticRenderFns } from "./CoderzCourse.vue?vue&type=template&id=1c0522fa"
import script from "./CoderzCourse.vue?vue&type=script&lang=js"
export * from "./CoderzCourse.vue?vue&type=script&lang=js"
import style0 from "./CoderzCourse.vue?vue&type=style&index=0&id=1c0522fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports